import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ReportTags } from "./report/ReportTags";
import { OrderTags } from "./order/OrderTags";
import { WebhookLogTags } from "./webhook-log/WebhookLogTags";
import { InventoryTags } from "./inventory/InventoryTags";
import { BackgroundJobTags } from "./background-job/BackgroundJobTags";
import { getAuthToken } from "@/auth/authToken";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

const httpBaseQuery = fetchBaseQuery({
  baseUrl: API_BASE_URL,
  prepareHeaders: (headers) => {
    headers.set("Accept", "application/json");
    const token = getAuthToken();
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

/** The single RTK Query API slice: every domain adds endpoints with `api.injectEndpoints(...)`; all cache tags are registered here. */
export const api = createApi({
  reducerPath: "api",
  baseQuery: httpBaseQuery,
  tagTypes: [
    ReportTags.DispatchReport,
    ReportTags.InventoryReport,
    ReportTags.ReceiptReport,
    ReportTags.AdjustmentReport,
    ReportTags.ToeReport,
    ReportTags.EstoreReport,
    ReportTags.TollReport,
    ReportTags.ReportUpload,
    ReportTags.ReportSnapshot,
    OrderTags.Order,
    WebhookLogTags.WebhookLog,
    InventoryTags.Inventory,
    BackgroundJobTags.BackgroundJob,
    BackgroundJobTags.BackgroundJobSchedule,
    BackgroundJobTags.BackgroundJobKind,
  ],
  endpoints: () => ({}),
});
